import { camelCase } from '../util.js'
const works = [
  {
    title: '为美好生活加速',
    desc: '为美好生活加速',
    thumb: camelCase('cases-brand-yincheng-0'),
    zpic: [
      camelCase('cases-brand-yincheng-lazyload-01')
    ]
  },
  {
    title: '诚意满满 加速全龄美好',
    desc: '诚意满满 加速全龄美好',
    thumb: camelCase('cases-brand-yincheng-1'),
    zpic: [
      camelCase('cases-brand-yincheng-lazyload-11')
    ]
  },
  {
    title: '音你而来 银城长三角音乐计划',
    desc: '音你而来 银城长三角音乐计划',
    thumb: camelCase('cases-brand-yincheng-2'),
    zpic: [
      camelCase('cases-brand-yincheng-lazyload-21')
    ]
  },
  {
    title: '各自美好 携手潮尚',
    desc: '各自美好 携手潮尚',
    thumb: camelCase('cases-brand-yincheng-3'),
    zpic: [
      camelCase('cases-brand-yincheng-lazyload-31')
    ]
  }
]
export default {
  name: '银城国际',
  logo: {
    default: camelCase('cases-brand-15'),
    active: camelCase('cases-brand-15-cover')
  },
  works
}
